import {
  ParlorHeadSection,
  ETypeMainHead,
  FUNERAL_SIDO,
  DTypeBreadCrumb,
  FUNERAL_SIGUNGU,
  CTypeSangjoService,
  excludeParlorList,
  FullWidthButton,
  LEGAL_TEXTS,
  GOI_WEB_URL,
  colors,
  FixedBottomButton,
  BinsoPriceTable,
} from "goi_common";
import { GetStaticPaths, GetStaticProps } from "next";
import parlors from "goi_common/src/constants/parlors_detail.json";

import React from "react";
import { ParlorDetailProps, BTypeTabs } from "goi_common";
import { parlorRegion } from "@/constants/parlorRegion";
import Head from "next/head";
import { Stack, Box } from "@mui/material";

const { regionColor, targetSidos } = parlorRegion;

const BreakLine = () => {
  return (
    <Box padding="0 20px">
      <Box
        width="100%"
        height="1px"
        style={{ background: colors.gray900 }}
        margin="0 0 20px"
        padding="0 20px"
      />
    </Box>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = parlors
    .filter((res) => targetSidos.includes(res.sido))
    .map((parlor) => ({
      params: {
        id: String(parlor.id),
      },
    }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const id = params?.id;
  let parlor;
  let district;
  let name = "";
  let description = "";

  if (id) {
    parlor = parlors.find((parlor) => parlor.id === Number(id));
    if (parlor) {
      name = parlor.companyname;

      district = parlor.address.slice(0, 2);
      if (parlor.address.split(" ")[0].length == 4)
        district = parlor.address[0] + parlor.address[2];

      const descParts = [
        `${parlor.companyname} 장례 서비스를 안내합니다`,
        `고이장례연구소에서 e하늘 장사정보 기반으로 안내드립니다`,
        `주소 : ${parlor.address}`,
        `장례지도사 동행 서비스`,
        `임종 준비부터 장례 마무리까지`,
      ].filter(Boolean);
      description = descParts.join(' | ');
    }
  }

  return {
    props: {
      defaultParlor: parlor,
      pageDescription: description,
      pageKeywords: `${parlor?.companyname} 장례 서비스, ${parlor?.companyname} 얼마, ${parlor?.companyname} 앰뷸런스, ${parlor?.companyname} 수의, ${parlor?.companyname} 유골함, ${parlor?.companyname} 도우미, ${parlor?.companyname} 비용, ${parlor?.companyname} 할인, ${parlor?.companyname} 전화번호`,
      pageOgTitle: `${parlor?.companyname} 장례 서비스·상조 안내 (${district}) | 서울경기인천 장례정보 [고이장례연구소]`,
      pageOgDescription: description,
      pageOgImage: parlor?.images[0]?.url || "",
      hasError: !parlor,
    },
  };
};

export default function flower({
  defaultParlor,
  pageOgTitle,
}: {
  defaultParlor: ParlorDetailProps;
  pageOgTitle: string;
}) {
  const regionParlors = parlors.filter((res) => targetSidos.includes(res.sido));
  const sidoName = FUNERAL_SIDO.get(Number(defaultParlor.sido));
  const sigunguName = FUNERAL_SIGUNGU.get(Number(defaultParlor.sido))?.get(
    Number(defaultParlor.sigungu)
  );

  const carouselItems = regionParlors.map((res, i) => {
    return {
      "@type": "ListItem",
      name: `(비용안내) ${res.companyname}`,
      image: `${res.images[0].url}`,
      url: `https://www.metropolitan-funeral.co.kr/parlor-places/${res.id}/`,
      position: i + 1,
    };
  });

  const carouselRichSearch =
    regionParlors.length > 6
      ? {
          "@context": "http://schema.org",
          "@type": "ItemList",
          itemListElement: carouselItems,
        }
      : {};
  if (excludeParlorList.includes(String(defaultParlor.id))) {
    return (
      <>
        <Head>
          <title>{pageOgTitle}</title>
        </Head>
        <ParlorHeadSection
          component={
            <>
              <DTypeBreadCrumb
                mainColor={regionColor}
                firstItem={{
                  text: `${sidoName} 장례식장`,
                  href: `/price-funeral/${sidoName} 지역 장례식장 추천/`,
                  event: {
                    domain: "metro",
                    path: "prlr_service",
                    trigger_and_target: "br_crumb_sido_prlr_list",
                  },
                }}
                secondItem={{
                  text: `${sigunguName} 장례식장`,
                  href: `/price-funeral/${sidoName} 지역-${sigunguName} 장례식장 추천/`,
                  event: {
                    domain: "metro",
                    path: "prlr_service",
                    trigger_and_target: "br_crumb_sigungu_prlr_list",
                  },
                }}
                goiHomeEvent={{
                  domain: "metro",
                  path: "prlr_service",
                  trigger_and_target: "br_crumb_goi_home",
                }}
              />
              <ETypeMainHead
                mainColor={regionColor}
                defaultParlor={defaultParlor}
                title={`${defaultParlor.companyname}`}
                managed_type={defaultParlor.managed_type}
                event={{
                  domain: "metro",
                  path: "prlr_service",
                  trigger_and_target: "uv_mth_req",
                }}
              />
            </>
          }
        />
        <Stack>해당 장례식장 요청으로 정보를 공개하지 않습니다.</Stack>
      </>
    );
  }
  return (
    <>
      <Head>
        <title>{pageOgTitle}</title>
        {regionParlors.length > 5 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(carouselRichSearch),
            }}
          />
        )}
      </Head>
      <ParlorHeadSection
        component={
          <>
            <DTypeBreadCrumb
              mainColor={regionColor}
              firstItem={{
                text: `${sidoName} 장례식장`,
                href: `/price-funeral/${sidoName} 지역 장례식장 추천/`,
              }}
              secondItem={{
                text: `${sigunguName} 장례식장`,
                href: `/price-funeral/${sidoName} 지역-${sigunguName} 장례식장 추천/`,
              }}
            />
            <ETypeMainHead
              mainColor={regionColor}
              defaultParlor={defaultParlor}
              title={`${defaultParlor.companyname} 상조 서비스`}
              managed_type={defaultParlor.managed_type}
              event={{
                domain: "metro",
                path: "prlr_service",
                trigger_and_target: "uv_mth_req",
              }}
            />
            <BreakLine />
            <Stack width="100%" padding="0 20px">
              <Box className="subtitle_14_b gray900" marginBottom="12px">
                {defaultParlor.companyname} 예상 빈소 이용료와, 고이 상조 이용 시 
                전체 예상 장례 비용(자체 추산)을 안내해드립니다.
              </Box>
              <FullWidthButton
                text="예상 총 장례 비용 확인하기"
                backgroundColor={regionColor.c300}
                href={GOI_WEB_URL + `/match/parlor-requests/${defaultParlor.id}/?utm_source=dogsound`}
                event={{
                  domain: "dggb",
                  path: "prlr_item_service",
                  trigger_and_target: "CTA_expected_cost",
                }}
              />
              <Box className="caption_11_r gray700" whiteSpace="pre-line" margin="12px 0">
                {LEGAL_TEXTS.UNRELATED}
              </Box>
            </Stack>
          </>
        }
      />

      <BTypeTabs
        mainColor={regionColor}
        href={`parlor-places/${defaultParlor.id}`}
        selectTab="상조 서비스"
        defaultParlor={defaultParlor}
        event={{
          domain: "metro",
          path: "prlr_service",
          trigger_and_target: "BType_tab",
        }}
      />

      <Stack style={{ background: regionColor.c100 }} padding="0 20px">
        <Box className="subtitle_16_b gray900" padding="12px 0 4px">
          빈소 이용료
        </Box>
        <BinsoPriceTable
          defaultParlor={defaultParlor}
          mainColor={regionColor}
        />
        <Box className="caption_11_r gray700" whiteSpace="pre-line" margin="12px 8px 20px">
          {LEGAL_TEXTS.COST_VARIABILITY}
        </Box>
      </Stack>
      <Stack>
        <Box className="subtitle_16_b gray900" padding="12px 20px 0">
          고이 상조 이용 시 상조 비용
        </Box>
        <CTypeSangjoService
          defaultParlor={defaultParlor}
          mainColor={regionColor}
          event={{
            domain: "metro",
            path: "prlr_service",
            trigger_and_target: "uv_mth_req_btom",
          }}
        />
      </Stack>

      <FixedBottomButton 
        text="예상 총 장례 비용 확인하기" 
        backgroundColor={regionColor.c300}
        href={GOI_WEB_URL + `/match/parlor-requests/${defaultParlor.id}/?utm_source=dogsound`}
        event={{
          domain: "metro",
          path: "prlr_compare",
          trigger_and_target: "Fixed_CTA",
        }} />
    </>
  );
}
